import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TiTick } from "react-icons/ti";

export const MultiSelect = ({
  name,
  label,
  options,
  textarea = false,
  rules,
  multi = true,
  placeholder = "دیگر بیماری‌ها………",
}) => {
  const {
    control,
    getValues,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  const handleCheckboxChange = (optionValue, isChecked) => {
    const currentValues = getValues(name) || [];
    if (isChecked) {
      setValue(name, [...currentValues, optionValue]);
    } else {
      setValue(
        name,
        currentValues.filter((value) => value !== optionValue)
      );
    }
    trigger(name); // Trigger validation
  };

  return (
    <div className=" shadow shadow-gray-400 rounded-lg block text-md font-medium text-gray-800 text-right mb-5 p-2">
      {multi && (
        <>
          <h3 className=" mb-1">{label}</h3>
          <Controller
            name={name}
            control={control}
            defaultValue={[]}
            rules={
              rules
                ? {
                    validate: {
                      atLeastOneSelected: (value) =>
                        value.length > 0 || "لطفا حداقل یک گزینه انتخاب کنید.",
                    },
                  }
                : {}
            }
            render={({ field }) => (
              <div className="p-1">
                {options.map((option) => (
                  <div
                    key={option.value}
                    className="group flex items-center space-x-2 text-md text-gray-600  w-fit my-1"
                  >
                    <>
                      <input
                        type="checkbox"
                        checked={field.value.includes(option.value)}
                        className="hidden"
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          handleCheckboxChange(option.value, isChecked);
                        }}
                      />

                      <div
                        className={`w-4 h-4  rounded border-2 
              inline-flex justify-center items-center group-hover:border-bgBlue cursor-pointer transition-all duration-300 ease-out ${
                field.value.includes(option.value)
                  ? "bg-bgBlue border-bgBlue"
                  : "border-gray-600"
              }`}
                        onClick={() => {
                          const isChecked = !field.value.includes(option.value);
                          handleCheckboxChange(option.value, isChecked);
                        }}
                      >
                        {" "}
                        <TiTick
                          className={`w-3 h-3 rounded text-white  ${
                            field.value ? " block" : "hidden"
                          }`}
                        />
                      </div>
                    </>

                    <label
                      onClick={() => {
                        const isChecked = !field.value.includes(option.value);
                        handleCheckboxChange(option.value, isChecked);
                      }}
                      className="cursor-pointer"
                    >
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>
            )}
          />
        </>
      )}

      {textarea && (
        <div className="flex items-center justify-center">
          <Controller
            name={`other`}
            control={control}
            render={({ field }) => (
              <textarea
                {...field}
                placeholder={placeholder}
                className={`  rounded border-2 px-3 py-2 text-md my-2 w-full   ${"border-gray-300"} focus:outline-none focus:ring`}
              />
            )}
          />
        </div>
      )}
      {errors[name]?.message && (
        <div
          role="alert"
          aria-label={errors[name].message}
          className=" text-sm font-semibold text-red-500 text-right "
        >
          {errors[name].message}
        </div>
      )}
    </div>
  );
};
